import React, { useState } from "react";
import { TypeAnimation } from "react-type-animation";
import Navbar from "../Shared/Navbar/Navbar";
import "./Header.css";

const Header = () => {
  const [typingStatus, setTypingStatus] = useState("Initializing");

  return (
    <div className="bg-[url('/src/bg.png')] h-screen">
      <Navbar></Navbar>
      <div className="flex flex-col-reverse md:flex md:flex-row md:justify-center gap-10 md:gap-20 md:mt-10 ">
        <div>
          <div className="text-center">
            <h1 className="header text-7xl">Introducing</h1>
            <h2 className="about font-extrabold md:text-7xl text-4xl mr-6 md:mr-0 -mt-4 md:-mt-0">
              ABOUT ME
            </h2>
          </div>
          <TypeAnimation
            sequence={[
              1500,
              () => {
                setTypingStatus("Typing...");
                console.log(typingStatus);
              },
              "HI! I am Nusrat, a front-end web developer. My journey started with programmimg hero in 2022. I like to describe myself as a adamant person who doesn't easily give up.",
              () => {
                setTypingStatus("Done Typing");
              },
              1000,
              () => {
                setTypingStatus("Deleting...");
              },
              "",
              () => {
                setTypingStatus("Done Deleting");
              },
            ]}
            speed={3}
            wrapper="p"
            repeat={Infinity}
            className=" md:w-80 mx-auto md:text-end mt-3 px-5 text-lg"
          />
          <a href="https://drive.google.com/file/d/15yd6yTUuaEhoakkkjrA4BrzrWlepqwlp/view?usp=share_link">
            <button className="px-6 pb-2 pt-3 md:ml-36 rounded-3xl mt-7 md:mt-7 text git-button">
              MY RESUME
            </button>
          </a>
        </div>
        <div>
          <img
            // src={img}
            src="https://i.pinimg.com/originals/75/8f/1c/758f1cd8cede9c3e4711306fc030f4ce.gif"
            alt=""
            className="w-96 h-96 rounded-lg shadow-lg"
            data-aos="zoom-in-left"
          />
          <h1 className="md:text-start md:ml-10 text-3xl font-bold mt-3 name">
            Nusrat Jahan
          </h1>
          <h4 className="md:text-start md:ml-16 title">Front-End Developer</h4>
        </div>
      </div>
    </div>
  );
};

export default Header;
